(function() {
  'use strict';

  angular.module('component.settings', []);
})();
